






































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'c-modal-layout',

  model: {
    prop: 'isOpen',
    event: 'input'
  }
})
export default class ModalLayout extends Vue {
  @Prop({ type: Boolean, default: () => false }) isOpen!: boolean
  @Prop({ type: Boolean, default: () => false }) isSubmitDisabled!: boolean
  @Prop({ type: String, default: '' }) title!: string
  @Prop({ type: String, default: '' }) subtitle!: string
}
